module.exports = __webpack_public_path__ + "img/dataQuality.60f8d870.png";